import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
var CreateProjectFooter = function CreateProjectFooter(_ref) {
  var createDisabled = _ref.createDisabled,
    isSaving = _ref.isSaving,
    onCancelClick = _ref.onCancelClick,
    onCreateClick = _ref.onCreateClick,
    submitButtonLabel = _ref.submitButtonLabel;
  var _useLocale = useLocale(function (_ref2) {
      var locale = _ref2.locale;
      return require("../i18n/".concat(locale, ".json"));
    }),
    T = _useLocale.T;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "ProjectModal_cancel_button",
    onClick: onCancelClick,
    style: {
      minWidth: '40px',
      marginRight: '16px'
    },
    variant: Button.VARIANTS.TERTIARY,
    disabled: isSaving
  }, T.translate('FOOTER_CANCEL_BUTTON')), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "ProjectModal_create_button",
    disabled: createDisabled,
    loading: isSaving,
    onClick: onCreateClick,
    variant: Button.VARIANTS.PRIMARY
  }, submitButtonLabel));
};
CreateProjectFooter.propTypes = {
  createDisabled: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  submitButtonLabel: PropTypes.string.isRequired
};
export default CreateProjectFooter;
//# sourceMappingURL=component.js.map